import { useState, useContext } from "react";
import { Outlet, Navigate,Link } from "react-router-dom";
import SingIn from "../pages/SingIn";
import SingUp from "../pages/SingUp";
import Home from "../pages/Home";
import ThemeContext from "../context/ThemeContext";
import UserContext from "../context/UserContext";
import { getSuggestedQuery } from "@testing-library/react";
import Headerstr from "./Headerstr";
import Sidebar from "./Sidebarstr";
import SternaSide from "./sidebars/sterna/SternaSide";




//export const isLoggedIn = false;



export const isLoggedIn = localStorage.getItem('login');
//const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('login'));
//const [isLoggedIn, setIsLoggedIn] = useState(false);

//export const [isLoggedIn, setIsLoggedIn] = useState(false);

//const [isLoggedIn, setIsLoggedIn] = useState(false);
const MainLayout = () => {
  
 // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const {theme, setTheme} = useContext(ThemeContext);
  const {users, setUsers} = useContext(UserContext);  

    if(!isLoggedIn)   {
        return <Navigate to="/sing-in" replace/>
    }
    return (
      <div>
      
  <Headerstr /> 
  <Outlet/>  

  </div>
 

    );
};


/*
          <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <ul>
          <li class="bg-slate-400">
          <div className="flex lg:flex-1"> 
            <Link to="/">Home</Link>
            </div>
          </li>
          <li>
            <Link to="Sing-in">Login</Link>
          </li>
          <li>
            <Link to="Sing-up">Sing Up</Link>
          </li>
        </ul>
      </nav> */


      export default MainLayout;
